var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Tag } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';
import { TagModal } from '../modals/tag';
import styles from './tag.module.scss';
import { TagOperation } from './types';
const actionFormatter = (node) => [
    {
        id: uuid(),
        type: 'out',
        label: 'arrow',
        connection: node.payload.nextNodeId || uuid(),
    },
];
export class TagNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { node: { payload: { operation, tags }, }, } = this.props;
        const { color, name } = tags[0];
        return (_jsx(FlowNode, { color: TagNode.color, icon: TagNode.icon, label: operation === TagOperation.TAG ? 'Add tag' : 'Remove tag', text: _jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Tag, Object.assign({ className: styles.tag, color: color, noBorder: true }, { children: name }), name), tags.length > 1 && (_jsxs("span", Object.assign({ className: styles.tagsNumber }, { children: ["+", tags.length - 1] })))] })), onEdit: this.triggerEdit }));
    }
}
TagNode.icon = 'tag';
TagNode.label = 'Add / Remove tag';
TagNode.color = flowNodeColor.blue;
TagNode.translatePayload = formatPortsHelper(actionFormatter);
TagNode.ActionModal = TagModal;
TagNode.actionTrigger = { type: AutomationNodeTypes.TAG };
TagNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    payload.nextNodeId = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], TagNode.prototype, "triggerEdit", null);
